import React, { Component } from 'react';
import _ from 'lodash';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import { FooterBlock } from 'components/landing/components';

import config from 'config/careers';
import Header from './Header';
import PerksList from './PerksList';
import PositionList from './PositionList';

import './Careers.css';

const dumbCareers = dumbBem('l-careers');
const CareersWrp = tx(dumbCareers)('div');

export class Careers extends Component {
  constructor(props) {
    super(props);

    this.perksRef = React.createRef();
    this.offersRef = React.createRef();

    _.bindAll(this, ['onNavigate']);
  }

  onNavigate(url) {
    const { history, location: { pathname } } = this.props;
    history.push(`${pathname}/${url}`);
  }

  render() {
    return (
      <CareersWrp>
        <Header
          offersRef={this.offersRef}
          perksRef={this.perksRef}
          title={config.header.title}
          description={config.header.description}
        />

        <PerksList
          perksRef={this.perksRef}
          title={config.contentBlocks.perks.title}
          perks={config.contentBlocks.perks.blocks}
        />

        <PositionList
          offersRef={this.offersRef}
          title={config.contentBlocks.offers.title}
          positions={config.contentBlocks.offers.blocks}
          onNavigate={this.onNavigate}
        />

        <FooterBlock />
      </CareersWrp>
    );
  }
}

export default Careers;



// WEBPACK FOOTER //
// ./src/components/landing/pages/careers/Careers.js